module.exports = __webpack_public_path__ + "img/keep.d9d3527a.png";